import { render, staticRenderFns } from "./DeliverySlotSetter.vue?vue&type=template&id=f41d7fd2"
import script from "./DeliverySlotSetter.vue?vue&type=script&lang=js"
export * from "./DeliverySlotSetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports